export const SEARCH_FORM_SUBMIT = 'STAFF.Q.SECTIONS.SEARCH_FORM_SUBMIT';
export const FETCH_LIST = 'STAFF.Q.SECTIONS.FETCH_LIST';
export const FETCH_ONE = 'STAFF.Q.SECTION.FETCH_ONE';
export const CLEAR_ONE = 'STAFF.Q.SECTION.CLEAR_ONE';
